import React, { useState, useEffect } from "react";
import { getUser } from "../../Utils/auth";
import { timeAgo } from "../../Utils/getUserUtitls";
import Loader from "../Loader/Loader";
import useApiLoader from "../../Utils/useApiLoader";
import api from "../../setupMiddleware";

const Notifications = () => {
  const user = getUser();
  const [recentActivities, setRecentActivities] = useState([]);
  const loading = useApiLoader();

  const getRecentActivity = async () => {
    api
      .get(`/api/notifications/${user?.id}`)
      .then((res) => {
        if (res && res.status === 200) {
          const recentItems = res.data?.data;
          setRecentActivities(recentItems);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const setReadNotification = async () => {
    try {
      api
        .post(`/api/notifications/mark-all-read`, { user_id: user?.id })
        .then((res) => {
          if (res && res.status === 200) {
            // setNotificationCount(0);
          }
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getRecentActivity();
    setReadNotification();
  }, []);

  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        <div className="relative w-full bg-white rounded-xl border border-[#a48572]/10 shadow p-4">
          <p>
            <span className="block text-lg font-medium text-[#142b70]">
              Recent Activities
            </span>
          </p>
          <span className="block text-xs text-[#142b70]/80 mb-2">
            Latest updates across the organization
          </span>
          <hr />
          <div className="flex flex-col gap-4 mt-4">
            {recentActivities.length > 0 ? (
              recentActivities.map((activity, idx) => (
                <div
                  key={idx}
                  className="flex items-start bg-[#c30f0a]/5 p-4 rounded-xl"
                >
                  {/* content */}
                  <div className="flex flex-col">
                    <span className="text-[12px] text-[#c30f0a]">
                      {activity.type === "leave"
                        ? "Leave Approved"
                        : activity.type === "leave_application"
                        ? "Leave Applied"
                        : activity.type === "user_creation"
                        ? "User Created"
                        : ""}
                    </span>
                    <span className="text-[12px] text-[#142b70]">
                      {activity.message}
                    </span>
                    <span className="text-xs text-[#142b70]/50">
                      {timeAgo(activity.created_at)}
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-6">
                <p className="text-[12px] text-[#142b70]">No Notifications</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Notifications;
